import { ACCOUNT_API_HOST, SELL_API_HOST } from "config";
import { HttpAPi } from "shared/http-api";

export const sellHttpApi = HttpAPi(SELL_API_HOST);
export const accountHttpApi = HttpAPi(ACCOUNT_API_HOST);
